import React from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { useErrorCode, useRelayState } from "../hook";
import DialogAlert from "@common/components/DialogAlert";
import { cleanAuthenticatedUser } from "@services/user/hooks/useAuthenticatedUser";

const LoginFailure = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigateToRelayState = useRelayState();
  const errorCode = useErrorCode();
  const statusCode = searchParams.get("status_code");

  return (
    <DialogAlert
      severity="error"
      open
      title={t("Error")}
      message={t(errorCode)}
      onClose={() => {
        cleanAuthenticatedUser();
        navigateToRelayState();
      }}
      closeButtonLabel={t("Return to Login page")}
    />
  );
};

export default LoginFailure;
